import React, { useState } from 'react'
import classnames from 'classnames'
// import moment from 'moment-timezone'
import { useErrorService, useNotificationService } from '@abroad/components'
import API from '../../utils/API'
import { DeleteConfirmationPrompt } from '../common'

const entityLabels = {
  company: 'Organization',
  network: 'Network',
}

const EntityArchiveAction = ({
  type,
  name,
  entityId,
  isArchived,
  onChanged,
}) => {
  const [isBusy, setIsBusy] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  // const [impact, setImpact] = useState(null)
  const Error = useErrorService()
  const Notification = useNotificationService()
  const label = entityLabels[type]

  const getEntityId = async () => {
    if (entityId) return entityId
    const { data } = await API.AdminAPI.entityService.getEntityByName(
      type,
      name,
    )
    return data._id
  }

  const updateArchived = async (id, nextIsArchived) => {
    await API.AdminAPI.entityService.setEntityArchived(type, id, nextIsArchived)
    setShowConfirm(false)
    setIsBusy(false)
    Notification.showNotification(
      `${label} has been ${nextIsArchived ? 'archived' : 'restored'}!`,
      'success',
    )
    onChanged(name)
  }

  const handleArchiveClick = () => {
    if (isBusy) return
    setShowConfirm(true)
    // Impact preview is not shown in the dialog right now, so it is not fetched.
    // const { data } = await API.AdminAPI.entityService.getEntityArchiveImpact(type, id)
    // setImpact({ id, ...data })
  }

  const handleConfirmArchive = async () => {
    if (isBusy) return
    setIsBusy(true)
    try {
      const id = await getEntityId()
      await updateArchived(id, true)
    } catch (e) {
      setIsBusy(false)
      Error.showError(e)
    }
  }

  const handleRestoreClick = async () => {
    if (isBusy) return
    setIsBusy(true)
    try {
      const id = await getEntityId()
      await updateArchived(id, false)
    } catch (e) {
      setIsBusy(false)
      Error.showError(e)
    }
  }

  // Running-experience warning is disabled for now (needs the impact preview above).
  // const renderConfirmation = () => {
  //   const { runningExperience } = impact
  //   return (
  //     <>
  //       Are you sure you want to archive {name}?
  //       {runningExperience && (
  //         <span className='d-block text-red-500 mt-2'>
  //           This network is linked to an experience that has not ended yet:{' '}
  //           {runningExperience.title} (
  //           {runningExperience.programDates?.questEndDate
  //             ? `ends ${moment(
  //                 runningExperience.programDates.questEndDate,
  //               ).format('MM-DD-YYYY')}`
  //             : 'no end date set'}
  //           ). Set an end date or remove it before archiving.
  //         </span>
  //       )}
  //     </>
  //   )
  // }

  return (
    <>
      <a
        href='javascript:void(0)'
        className={classnames('text-red-500 cursor-pointer', {
          'cursor-disabled': isBusy,
        })}
        onClick={(e) => {
          e.preventDefault()
          if (isArchived) {
            handleRestoreClick()
          } else {
            handleArchiveClick()
          }
        }}>
        {isArchived ? 'Restore' : 'Archive'}
      </a>
      <DeleteConfirmationPrompt
        showModal={showConfirm}
        setShowModal={setShowConfirm}
        isDeleteLoading={isBusy}
        handleDelete={handleConfirmArchive}
        message={`Are you sure you want to archive ${name}?`}
        buttonConfirmText='Archive'
      />
    </>
  )
}

export default EntityArchiveAction
